import {
  CpatAssessmentQuestion,
  QuestionStatus,
  QuestionType,
} from "api/resources/cpat/types"

export const dummyQuestionBank: CpatAssessmentQuestion[] = Array.from(
  { length: 30 },
  (_, index) => {
    const questionNumber = index + 1

    let status: QuestionStatus = QuestionStatus.UNREAD

    if (questionNumber <= 10) {
      if (questionNumber % 3 === 0) {
        status = QuestionStatus.MARKED_FOR_REVIEW
      } else if (questionNumber % 2 === 0) {
        status = QuestionStatus.UNATTEMPTED
      } else {
        status = QuestionStatus.ATTEMPTED
      }
    }

    return {
      id: questionNumber,
      sequence: questionNumber,
      status,
      question: {
        id: 101,
        text: "Ms Hall and Mrs Harris teach Geography to Grade 9 students. Which teacher is more likely to have a healthy relationship with students: Ms Hall, who uses positive reinforcement, or Mrs Harris, who uses strict discipline and corporal punishment?",
        options: ["Ms Hall", "Mrs Harris", "None", "Both"],
        ordered: false,
        questionType: QuestionType.SINGLE_CORRECT,
      },
      response: status === QuestionStatus.ATTEMPTED ? [0] : null,
    }
  }
)
